import { Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";

export function Header({ settings }) {
  const [open, setOpen] = useState(false);
  const phone = settings?.phone || "07 60 00 10 96";
  const links = [
    { to: "/", label: "Accueil" },
    { to: "/comparatif", label: "Comparatif" },
    { to: "/commander", label: "Réserver" },
  ];
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-brand-green/10">
      <div className="brand-container flex items-center justify-between h-16">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2.5">
          <img src="https://static.prod-images.emergentagent.com/jobs/5d3e454e-4085-403e-80e5-061446169ecd/images/31c9b1b8bb3210b975abbcc2ea527dbbea9ff10f2468d09dc08c291025226393.png" alt="Zeitrog" className="h-14 w-14 object-contain rounded-full" />
          <span className="font-serif text-2xl sm:text-3xl font-bold leading-none">
            <span className="text-brand-green">Zeit</span><span className="text-brand-gold">rog</span>
          </span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`} className="text-sm font-medium text-brand-green/80 hover:text-brand-green transition-colors">
              {l.label}
            </Link>
          ))}
          <a href={`tel:${phone.replace(/\s/g, "")}`} data-testid="header-phone" className="inline-flex items-center gap-2 rounded-full bg-brand-green text-white px-4 py-2 text-sm font-semibold hover:bg-brand-greenLight transition-colors">
            <Phone className="w-4 h-4" /> {phone}
          </a>
        </nav>
        <button data-testid="menu-toggle" className="md:hidden text-brand-green" onClick={() => setOpen(!open)}>
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-brand-green/10 bg-white/95 px-4 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-brand-green font-medium py-1">
              {l.label}
            </Link>
          ))}
          <a href={`tel:${phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 text-brand-green font-semibold">
            <Phone className="w-4 h-4" /> {phone}
          </a>
        </div>
      )}
    </header>
  );
}
